import { InputNumber } from 'primereact/inputnumber';

export const FiltroRangoNumerico = ({ valueMin, valueMax, onChange, isCurrency = true, icon = isCurrency ? "pi pi-dollar" : "pi pi-hashtag", minProps = {}, maxProps = {}, ...props }) => {
    return (
        <div className="flex gap-2 w-full">
            <div className="p-inputgroup w-6">
                <span className="p-inputgroup-addon bg-white px-2">
                    <i className={`${icon} text-primary text-sm`}></i>
                </span>
                <InputNumber mode={isCurrency ? "currency" : "decimal"} currency="USD" locale="en-US" {...props} {...minProps}
                    value={valueMin} onValueChange={(e) => onChange({ min: e.value, max: valueMax })} placeholder="Desde" className="w-6" />
            </div>
            <div className="p-inputgroup w-6">
                <span className="p-inputgroup-addon bg-white px-2">
                    <i className={`${icon} text-primary text-sm`}></i>
                </span>
                <InputNumber mode={isCurrency ? "currency" : "decimal"} currency="USD" locale="en-US" {...props} {...maxProps}
                    value={valueMax} onValueChange={(e) => onChange({ min: valueMin, max: e.value })} placeholder="Hasta" className="w-6" />
            </div>
        </div>
    );
};